import { ReactNode } from 'react';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';

interface LazySectionProps {
  children: ReactNode;
  fallback?: ReactNode;
  className?: string;
  rootMargin?: string;
  id?: string;
}

export const LazySection = ({ 
  children, 
  fallback = <div className="section-spacing flex justify-center"><div className="animate-pulse text-muted-foreground">Loading...</div></div>,
  className = "",
  rootMargin = "200px",
  id
}: LazySectionProps) => {
  const { elementRef, hasBeenVisible } = useIntersectionObserver({
    rootMargin,
    freezeOnceVisible: true
  });

  return (
    <div ref={elementRef} className={className} id={id}>
      {hasBeenVisible ? children : fallback}
    </div>
  );
};